<template>
  <NuxtLink to="/u/logowanie" class="btn btn-secondary btn-lg max-w-[185px]">
    <i class="icon-arrow-button text-10 rotate-180" />
    <span>Powrót do logowania</span>
  </NuxtLink>
</template>
